"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDate = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _sbButton = require("../sb-button");

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOP_LEFT = _constants.positions.TOP_LEFT,
    TOP_RIGHT = _constants.positions.TOP_RIGHT,
    BOTTOM_LEFT = _constants.positions.BOTTOM_LEFT,
    BOTTOM_RIGHT = _constants.positions.BOTTOM_RIGHT;

var NOOP = function NOOP() {};

var TODAY = new Date();

var SbDate = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbDate, _PureComponent);

  var _super = _createSuper(SbDate);

  function SbDate(props) {
    var _this;

    _classCallCheck(this, SbDate);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnDateClick", function (day) {
      var onChange = _this.props.onChange;
      onChange({
        date: new Date(day)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPrevYearClick", function () {
      _this.handleOnControlClick({
        diff: -1,
        year: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPrevMonthClick", function () {
      _this.handleOnControlClick({
        diff: -1,
        month: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnNextMonthClick", function () {
      _this.handleOnControlClick({
        diff: 1,
        month: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnNextYearClick", function () {
      _this.handleOnControlClick({
        diff: 1,
        year: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnControlClick", function (_ref) {
      var diff = _ref.diff,
          year = _ref.year,
          month = _ref.month;
      var _this$props = _this.props,
          activeDate = _this$props.activeDate,
          selectedDate = _this$props.selectedDate,
          onControlChange = _this$props.onControlChange;
      var newActiveDate = new Date(activeDate || selectedDate || TODAY);
      newActiveDate.setDate(1);

      if (year) {
        newActiveDate.setFullYear(newActiveDate.getFullYear() + diff);
      }

      if (month) {
        newActiveDate.setMonth(newActiveDate.getMonth() + diff);
      }

      onControlChange(newActiveDate);
    });

    _defineProperty(_assertThisInitialized(_this), "getFirstDay", function (d, firstDayOfWeek) {
      var date = new Date(d);
      var day = date.getDay();
      var diff = date.getDate() - day + (day === 0 ? -6 : firstDayOfWeek);
      return new Date(date.setDate(diff));
    });

    _defineProperty(_assertThisInitialized(_this), "createDaysRange", function (day, startingWeekDay) {
      var date = day || new Date();
      var firstDayOfMonth = new Date(date);
      firstDayOfMonth.setDate(1);
      var startingDate = firstDayOfMonth.getDay() === startingWeekDay ? firstDayOfMonth : _this.getFirstDay(firstDayOfMonth, startingWeekDay);
      var days = [];

      for (var i = 0; i < 42; i += 1) {
        days.push(new Date(startingDate));
        startingDate.setDate(startingDate.getDate() + 1);
      }

      return days;
    });

    _defineProperty(_assertThisInitialized(_this), "renderWeekDays", function () {
      var weekDays = _this.props.weekDays;
      return /*#__PURE__*/_react.default.createElement("tr", null, weekDays.map(function (day) {
        return /*#__PURE__*/_react.default.createElement("th", {
          key: "".concat(_this.instanceId, "-").concat(day)
        }, day);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCalendar", function () {
      var _this$props2 = _this.props,
          selectedDate = _this$props2.selectedDate,
          activeDate = _this$props2.activeDate,
          startingWeekday = _this$props2.startingWeekday;

      var days = _this.createDaysRange(activeDate || selectedDate, startingWeekday);

      return /*#__PURE__*/_react.default.createElement("table", {
        className: "sb-date-calendar"
      }, /*#__PURE__*/_react.default.createElement("thead", null, _this.renderWeekDays()), /*#__PURE__*/_react.default.createElement("tbody", null, _this.renderDays(days, startingWeekday)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDays", function (days) {
      var chunks = (0, _utils.chunkArray)(days, 7);
      return chunks.map(function (week, i) {
        return _this.renderOneWeek(week, i);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderOneWeek", function (days, i) {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: "".concat(_this.instanceId, "-week-").concat(i)
      }, days.map(function (day) {
        return _this.renderOneDay(day);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderOneDay", function (day) {
      var _this$props3 = _this.props,
          activeDate = _this$props3.activeDate,
          selectedDate = _this$props3.selectedDate;
      var currentMonth = activeDate || selectedDate || TODAY;
      var isToday = (0, _utils.compareDates)(TODAY, day) ? 'today' : null;
      var otherMonth = !(0, _utils.isSameMonth)(currentMonth, day) ? 'other-month' : null;
      var isSelected = (0, _utils.compareDates)(selectedDate, day) ? 'selected' : null;
      var className = (0, _classnames.default)(isToday, isSelected, otherMonth);
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
        _react.default.createElement("td", {
          key: "".concat(_this.instanceId, "-").concat(day.getDate()),
          className: className,
          onClick: function onClick() {
            _this.handleOnDateClick(day);
          }
        }, /*#__PURE__*/_react.default.createElement("span", null, day.getDate()))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "renderControls", function () {
      var _this$props4 = _this.props,
          activeDate = _this$props4.activeDate,
          selectedDate = _this$props4.selectedDate,
          months = _this$props4.months;
      var currentDate = activeDate || selectedDate || TODAY;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "calendar-controls"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "prev"
      }, /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: _this.handleOnPrevYearClick
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-chevron-double-left"
      })), /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: _this.handleOnPrevMonthClick
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-chevron-left"
      }))), /*#__PURE__*/_react.default.createElement("span", null, "".concat(months[currentDate.getMonth()], " ").concat(currentDate.getFullYear())), /*#__PURE__*/_react.default.createElement("div", {
        className: "next"
      }, /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: _this.handleOnNextMonthClick
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-chevron-right"
      })), /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        onClick: _this.handleOnNextYearClick
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-chevron-double-right"
      }))));
    });

    _this.instanceId = (0, _v.default)();
    return _this;
  }

  _createClass(SbDate, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          open = _this$props5.open,
          position = _this$props5.position,
          dateRef = _this$props5.dateRef;

      if (!open) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('date-picker', position),
        ref: dateRef
      }, this.renderControls(), this.renderCalendar());
    }
  }]);

  return SbDate;
}(_react.PureComponent);

exports.SbDate = SbDate;

_defineProperty(SbDate, "propTypes", {
  open: _propTypes.default.bool,
  selectedDate: _propTypes.default.instanceOf(Date),
  activeDate: _propTypes.default.instanceOf(Date),
  onChange: _propTypes.default.func,
  onControlChange: _propTypes.default.func,
  position: _propTypes.default.oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_LEFT, BOTTOM_RIGHT]),
  dateRef: _propTypes.default.func,
  weekDays: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  months: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  startingWeekday: _propTypes.default.number.isRequired
});

_defineProperty(SbDate, "defaultProps", {
  open: false,
  selectedDate: TODAY,
  activeDate: null,
  onChange: NOOP,
  onControlChange: NOOP,
  position: TOP_LEFT,
  dateRef: NOOP
});
//# sourceMappingURL=sb-date.js.map